import React, { useEffect, useRef, useState } from 'react';
import logo from '../assets/sbqr-logo-metal.png';
import './SiteHeader.css';

const NAV_ITEMS = [
  { href: '/#portfolio', label: 'Возможности' },
  { href: '/qr/create/examples/', label: 'Примеры', match: '/qr/create/examples/' },
  { href: '/qr/create/text/', label: 'QR с дизайном', match: '/qr/create/' },
  { href: '/wp/', label: 'Инструкции' },
  { href: '/page/tariff.html', label: 'Тарифы' },
  { href: '/page/faq.html', label: 'Помощь' },
  { href: '/page/cabinet_login.html', label: 'Войти в кабинет' }
];

function isCurrent(item) {
  const path = window.location.pathname;
  if (item.href === '/qr/create/text/') {
    return path.startsWith(item.match) && path !== '/qr/create/examples/';
  }
  return item.match ? path === item.match : path === item.href;
}

function SiteHeader() {
  const [open, setOpen] = useState(false);
  const buttonRef = useRef(null);

  useEffect(() => {
    function closeOnEscape(event) {
      if (event.key !== 'Escape') return;
      setOpen(false);
      buttonRef.current?.focus();
    }
    document.addEventListener('keydown', closeOnEscape);
    return () => document.removeEventListener('keydown', closeOnEscape);
  }, []);

  return (
    <header className="site-header">
      <div className="site-header__container site-header__inner">
        <a className="site-header__brand" href="/" aria-label="SBQR — на главную">
          <img src={logo} alt="SBQR" width="320" height="111" />
        </a>
        <button
          ref={buttonRef}
          className="site-header__menu-btn"
          type="button"
          aria-controls="site-navigation"
          aria-expanded={open}
          aria-label={open ? 'Закрыть меню' : 'Открыть меню'}
          onClick={() => setOpen((value) => !value)}
        >
          <span className="site-header__menu-icon" aria-hidden="true" />
        </button>
        <nav className={`site-nav${open ? ' site-nav--open' : ''}`} id="site-navigation" aria-label="Основная навигация">
          <ul className="site-nav__list">
            {NAV_ITEMS.map((item) => (
              <li key={item.href}>
                <a
                  className="site-nav__link"
                  href={item.href}
                  aria-current={isCurrent(item) ? 'page' : undefined}
                  onClick={() => setOpen(false)}
                >
                  {item.label}
                </a>
              </li>
            ))}
            <li>
              <a className="site-nav__link site-nav__link--accent" href="/page/QRcode_dlya_oplaty.html#form" onClick={() => setOpen(false)}>
                Создать QR бесплатно
              </a>
            </li>
          </ul>
        </nav>
      </div>
    </header>
  );
}

export default SiteHeader;
